import { inject, Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { KeycloakProfile } from 'keycloak-js';
import { environment } from '../../../environments/environment';

/**
 * Provides authentication services using Keycloak.
 *
 */
@Injectable({
  providedIn: 'root',
})
export class AuthService {

  readonly keycloak = inject(KeycloakService);

  bearer?: any;

  /**
   * Redirects the user to the login page.
   *
   * @returns {Promise<void>} A promise that resolves when the user is redirected to the login page.
   */
  redirectToLoginPage(): Promise<void> {
    return this.keycloak?.login();
  }

  /**
   * Retrieves the username of the currently authenticated user.
   *
   * @return {string} The username of the authenticated user.
   */
  getUserName(): string {
    try {
      return this.keycloak?.getUsername();
    } catch (error) {
      return '';
    }
  }

  /**
   * Load user profile
   * @returns 
   */
  async loadUserProfile(): Promise<KeycloakProfile | undefined> {
    try {
      const _this = this;
      this.keycloak?.getToken().then(function (jwtToken) {
        _this.bearer = jwtToken;
      });
      return await this.keycloak?.loadUserProfile();

    } catch (error) {
      return undefined;
    }
  }

  /**
   * Checks if the user is currently logged in.
   *
   * @return {boolean} - Returns true if the user is logged in, otherwise returns false.
   */
  isLoggedIn(): boolean {
    return this.keycloak?.isLoggedIn();
  }

  /**
   * 
   */
  isTokenExpired() {
    return this.keycloak?.isTokenExpired();
  }

  /**
   * Logs out the user from the Keycloak service.
   *
   * @return {void} This method does not return any value.
   */
  logout(): void {
    this.keycloak?.logout(environment.keycloak.postLogoutRedirectUri);
    localStorage.removeItem('userdata');
    localStorage.clear();
  }

  /**
   * Get Jwt token
   * @returns {Promise<void>}
   */

  async getToken() {
    if (!this.isLoggedIn()) {
      return null;
    }
    if (this.isTokenExpired()) {
      try {
        await this.keycloak?.updateToken();
      } catch (error) {
        return null;
      }
    }
    return this.keycloak?.getToken();
  }

}
